<template>
  <div class="my-wallet-content lianlian">
    <div class="account">
      <img src="../imgs/lianlian-wallet.png" alt="">
      <div v-if="!isNotData" class="account-btns">
        <el-button size="small" type="primary" @click="toWithdraw">
          提现
        </el-button>
        <el-button size="small" type="primary" @click="manageAccount">
          管理
        </el-button>
      </div>
    </div>
    <template v-if="!isNotData">
      <div class="account-money">
        <div class="account-money-item !w-[50%]">
          <div class="title">
            可用余额(元)
          </div>
          <div class="money">
            {{ isNull(data?.availableBalance) ? '--' : data?.availableBalance }}
          </div>
        </div>
  
        <div class="account-money-item !w-[50%]">
          <div class="title">
            冻结金额(元)
          </div>
          <div class="money">
            {{ isNull(data?.frozenAmount) ? '--' : data?.frozenAmount }}
          </div>
        </div>
      </div>
  
      <div class="account-info">
        <div class="left">
          <div class="account-info-title">
            <span v-if="term === 'server'" class="label">服务商：</span>
            <span v-if="term === 'agent'" class="label">代理商：</span>
            <span v-if="term === 'company'" class="label">企&nbsp;&nbsp;&nbsp;业：</span>
            <span class="value">{{ isNull(data?.bizName) ? '--' : data?.bizName }}</span>
          </div>
          <div class="account-info-title">
            <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
            <span class="value">{{ isNull(data?.accountNo) ? '--' : data?.accountNo }}</span>
          </div>
        </div>
        <el-popover popper-class="homepage-wallet-popover" placement="bottom-end" :width="460">
          <template #reference>
            <span class="account-info-btn">详细信息
              <svg-icon class="!w-3" icon="uiw:down" />
            </span>
          </template>
  
          <div class="flex flex-col py-2 px-2">
            <strong class="pb-4">基本信息</strong>
            <div class="finance-zl-info-box">
              <div>
                <label>账号名称：</label>
                <span>{{ data.bizName || '--' }}</span>
              </div>
              <div>
                <label>开户账号：</label>
                <span>{{ data.accountNo || '--' }}</span>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
    </template>
    <not-data-wallet v-else />

    <lianlian-withdraw
      :visible="showWithdrawDialog"
      :data="data"
      :term="term"
      :pay-phone="payInfo?.payPhone"
      :loading="withdrawLoading"
      @close="showWithdrawDialog = false"
      @confirm="doWithdraw"
    />

    <lianlian-valid-withdraw
      :visible="showWithdrawVerifyDialog"
      :data="data"
      :valid-info="validInfo"
      :loading="withdrawLoading"
      @confirm="doValidWithdraw"
      @close="showWithdrawVerifyDialog = false"
    />
  </div>
</template>

<script setup lang='ts'>
import { LianlianWithdraw, LianlianValidWithdraw, doLianLianWithdraw, doLianLianWithdrawVerify } from '@core/main';
import NotDataWallet from './NotDataWallet.vue';
import { onConfirm, SvgIcon } from '@vue3/components';
import { inject, Ref, computed, ref, reactive, nextTick } from 'vue';
import { isNull } from '@core/tools';
import { ElMessage } from 'element-plus';
import {
  EHasPayPassword, 
  ISecuritySettingDetail, 
  EFinanceLianStatus, 
  IFinanceLianWithdraw, 
  IFinanceLianWithdrawVerify, 
  IFinanceWallet, 
} from '@core/main/types';
import { useRouter } from 'vue-router';

const emit = defineEmits(['reload']);

const router = useRouter();

const data = inject<Ref<IFinanceWallet>>('data');
const term = inject<'server' | 'company' | 'agent'>('term');
const payInfo = inject<Ref<ISecuritySettingDetail>>('payInfo');

const withdrawLoading = ref(false);
const showWithdrawDialog = ref(false);
const showWithdrawVerifyDialog = ref(false);

const validInfo = reactive({
  txnId: 0,
  validToken: '',
});

const isNotData = computed(() => data.value?.userStatus !== EFinanceLianStatus.NORMAL);

async function doWithdraw(params: IFinanceLianWithdraw) {
  withdrawLoading.value = true;

  try {
    const { token, txnId: tx, revalid } = await doLianLianWithdraw(params);

    validInfo.validToken = token;
    validInfo.txnId = tx;

    if (revalid) {
      withdrawLoading.value = false;
      showWithdrawDialog.value = false;
      showWithdrawVerifyDialog.value = true;
      return;
    }

    ElMessage.success('提现中，有延迟请稍等......');
    showWithdrawDialog.value = false;

    nextTick(() => {
      emit('reload');
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  withdrawLoading.value = false;
}

async function doValidWithdraw(params: IFinanceLianWithdrawVerify) {
  withdrawLoading.value = true;

  try {
    await doLianLianWithdrawVerify(params);

    showWithdrawVerifyDialog.value = false;
    ElMessage.success('提现成功，有延迟请稍等......');

    nextTick(() => {
      emit('reload');
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  withdrawLoading.value = false;
}

const toWithdraw = () => {
  if (payInfo?.value?.hasPayPassword === EHasPayPassword.NOT_SET) {
    onConfirm({
      message: '您未设置支付密码，请前往设置！',
      okText: '去设置',
      onOk: async () => {
        router.push({ name: 'SecuritySettings' });
      },
    });
    return;
  }

  showWithdrawDialog.value = true;
};

const manageAccount = () => {
  router.push({
    name: 'FinanceLianManage',
    query: {
      id: data.value?.accountId,
      term: term,
    },
  });
};
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />